import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm text-gray-600">
          pMaster.uz is Sozlashlarni boshqaruv tizimi. Powered by{' '}
          <a
            href="https://thedevs.uz"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-700 hover:underline"
          >
            THEDEVS.UZ
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;

